import { Button, Icons } from '@healthinal/ui';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetMedi24PatientDetailsTransformedSuspense } from '../api/heurekaPatientDetails';
import ContentSection from '../components/ContentSection';
import HeurekaPatient from '../components/HeurekaPatient';
import { SharePatientDialog } from '../components/share-patient-dialog/SharePatientDialog';

export function PatientCallcenterMedi24() {
  const [showShareDialog, setShowShareDialog] = useState(false);

  const { patientId } = useParams();
  if (!patientId) {
    throw new Error('patient id needs to be set');
  }
  const { data: patientData } = useGetMedi24PatientDetailsTransformedSuspense(patientId);
  if (!patientData) {
    return null;
  }

  return (
    <ContentSection>
      <HeurekaPatient
        patientData={patientData}
        showPracticeEmail={true}
        headerAction={
          import.meta.env.VITE_IS_PARTNER_FEATURE_ACTIVE === 'true' && (
            <Button
              startDecorator={<Icons.IosShare />}
              variant={'outlined'}
              color={'neutral'}
              onClick={() => setShowShareDialog(true)}>
              An Partnerpraxis freigeben
            </Button>
          )
        }
      />
      <SharePatientDialog patientId={patientId} open={showShareDialog} onClose={() => setShowShareDialog(false)} />
    </ContentSection>
  );
}
